/**
 * AUTO-GENERATED by scripts/sync-chains.ts — DO NOT EDIT.
 * Source of truth: OpenSea REST API + scripts/chain-data.json
 * Run `pnpm sync-chains` to regenerate.
 */

export const CHAIN_IDS: Record<string, number> = {
  ethereum: 1,
  mainnet: 1,
  optimism: 10,
  unichain: 130,
  polygon: 137,
  matic: 137,
  monad: 143,
  shape: 360,
  flow: 747,
  hyperevm: 999,
  sei: 1329,
  soneium: 1868,
  ronin: 2020,
  abstract: 2741,
  megaeth: 4326,
  robinhood: 4663,
  somnia: 5031,
  b3: 8333,
  base: 8453,
  ape_chain: 33139,
  apechain: 33139,
  arbitrum: 42161,
  avalanche: 43114,
  gunzilla: 43419,
  ink: 57073,
  animechain: 69000,
  bera_chain: 80094,
  berachain: 80094,
  blast: 81457,
  zora: 7777777,
}

/**
 * Resolve a chain identifier to a numeric EVM chain ID.
 * Accepts a known chain name (e.g. "base") or a numeric string / number.
 */
export function resolveChainId(chain: string | number): number {
  if (typeof chain === "number") return chain
  const asNum = Number(chain)
  if (!Number.isNaN(asNum) && Number.isInteger(asNum)) return asNum
  const id = CHAIN_IDS[chain]
  if (id === undefined) {
    throw new Error(
      `Unknown chain "${chain}". Pass a numeric chain ID or use a known name: ${Object.keys(CHAIN_IDS).join(", ")}`,
    )
  }
  return id
}
